import React, { useState, useMemo, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FiChevronRight, FiClock, FiTrendingUp, FiLayers } from 'react-icons/fi'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import AuthContext from "../../../../../auth/auth-context";
import TradeContext from '../../../../../store/tradeState/tradeContext';
import InvestectTradeComponent from './InvestectTradeComponent'
import CapitecTradeComponent from './CapitecTradeComponent'
import BopCodeComponent from './components/BopCodeComponent';
import {Container, Title} from './TradeViewIntergrationContainer.styles'
import InvestecLogo from '../../../../../assets/Banks/investec-logo-cropped.png'
import CapitecLogo from '../../../../../assets/Banks/capitec-logo-cropped.png'
function TradeViewIntegrationContainer(props) {
  const {inTrade} = props;

  const renderBankLogo = (bankName) => {
    if(bankName === "Investec Bank") {
      return <img src={InvestecLogo} alt="Investec Bank Logo" style={{ width: '150px' }} />
    } else if (bankName === "Capitec Bank" || bankName === "Capitec Business") {
      return <img src={CapitecLogo} alt="Capitec Bank Logo" style={{ width: '150px' }} />
    } else {
      return null;
    }
  }

  return (
    <Container>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <Title style={{ marginBottom: 0 }}><FiLayers size={20} /> Trade View Integration</Title>
        {inTrade && inTrade.bank && renderBankLogo(inTrade.bank.display_name)}
      </div>
      {inTrade && inTrade.bank && inTrade.bank.display_name === "Investec Bank" && <InvestectTradeComponent inTrade={inTrade} setTradeScreen={props.setTradeScreen} />}
      {inTrade && inTrade.bank && (inTrade.bank.display_name === "Capitec Bank" || inTrade.bank.display_name === "Capitec Business") && <CapitecTradeComponent inTrade={inTrade} setTradeScreen={props.setTradeScreen} />}

    </Container>
  )
}

export default TradeViewIntegrationContainer

TradeViewIntegrationContainer.propTypes = {
  inTrade: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max_exchange_rate: PropTypes.number,
    trade_rate: PropTypes.number,
    status: PropTypes.string,
    bank: PropTypes.any,
    quotes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        createdAt: PropTypes.string,
        currencyPair: PropTypes.string,
        amount: PropTypes.number,
        rate: PropTypes.number,
      })
    ),
  }),
  setTradeScreen: PropTypes.func.isRequired,
}